import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import useFacility from "../../../utils/hooks/useFacility";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import { useTranslation } from "react-i18next";
import { checkComponentActive } from "../../../utils/checkComponentActive";
import EAAlert from "../shared/EAAlert";

const LimitedTicketShapePage: React.FC = () => {
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { shapeGroup, requestGetShapeGroup, loading } = useTickets();
  const facilityIds = useFacility();

  useEffect(() => {
    requestGetShapeGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  if (checkComponentActive(saleConfiguration.componentList, "Shapes") === false) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  }

  return (
    <>
      <div className="container">
        <EAPageHeader componentId="Shapes" />
        <EAPageMessage message={saleConfiguration.message_shapes} />

        <div className="limited-ticket-wrapper">
          {loading ? (
            <EASkeletonLoader height="200px" />
          ) : (
            <>
              {shapeGroup && (
                <>
                  {shapeGroup.map((item, index) => (
                    <LimitedTicketBlock item={item} sortType="shapeGroup" key={index} />
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default LimitedTicketShapePage;
